import { createContext, useContext } from "react";

// Context + hook live apart from the provider component so the provider file
// exports only a component (keeps Vite Fast Refresh happy), mirroring useAuth.
export const TourCtx = createContext(null);

export const useTour = () => useContext(TourCtx);
